import Blue from '~/core';

new Blue({
  name: 'Stackable Timeline',
  selector: '.stackable-content.stackable-content--timeline',
  setup(timeline) {
    // Insert Progress Bar
    timeline.insertAdjacentHTML(
      'beforeend',
      '<div class="stackable-content__progress"></div>'
    );

    // Timeline Variables
    let curHeight = 10;

    // Timeline Elements
    const progress = timeline.querySelector('.stackable-content__progress');
    const items = timeline.querySelectorAll('.stackable-content__item');
    const years = timeline.querySelectorAll('.stackable-content__year');

    // Set Progress Bar Height
    function checkProgress() {
      // Get Progress Bar Height
      const height = isAtBottomOfPage()
        ? timeline.offsetHeight
        : Math.min(
            Math.max(10, getVerticalDistanceFromCenter(timeline)),
            timeline.offsetHeight
          );

      // curHeight is our animated value
      curHeight += (height - curHeight) * 0.075;

      // Set Progress Bar Height
      progress.style.height = `${curHeight}px`;

      // Check Items In View
      checkShowItems(items, timeline, curHeight, 'stackable-content__item');
      checkShowItems(years, timeline, curHeight, 'stackable-content__year');

      requestAnimationFrame(checkProgress);
    }

    checkProgress();
  },
});

function checkShowItems(items, container, curHeight, className) {
  items.forEach((item) => {
    const itemTop = item.getBoundingClientRect().top;
    const contTop = container.getBoundingClientRect().top;
    const relTop = itemTop - contTop + 12;

    if (relTop <= curHeight && item.dataset.showing !== 'true') {
      item.classList.add(`${className}--shown`);
      item.dataset.showing = true;
    } else if (relTop > curHeight && item.dataset.showing){
      item.dataset.showing = false;
    }
  });
}

function getVerticalDistanceFromCenter(element) {
  const elementRect = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const centerOfViewport = viewportHeight / 2 + window.scrollY;
  const elementTop = elementRect.top + window.scrollY;
  return centerOfViewport - elementTop;
}

function isAtBottomOfPage() {
  const scrollTop = document.documentElement.scrollTop;
  const scrollHeight = document.documentElement.scrollHeight;
  const clientHeight = document.documentElement.clientHeight;
  return scrollTop + clientHeight >= scrollHeight;
}
